import {AxiosRequestConfig} from 'axios';
import request from '../../../axios';

export const getTransaction = async (params: GetTransactionPayload) => {
  const {data}: {data: GetTransactionData} = await request.get(
    `/api/v2/subscription/transaction-promotion`,
    {
      params: {
        ...params,
      },
    } as AxiosRequestConfig,
  );
  return data;
};
